import { PageHead } from '../components/list';
import './page.css';
import './help.css';

const PDF_URL = '/persas-kullanim-kilavuzu.pdf';

/** Yardım / Kullanım Kılavuzu — admin ve manager erişir. PDF gömülü gösterilir + indirilebilir. */
export function Help() {
  return (
    <div className="page">
      <PageHead
        eyebrow="Yardım"
        title="Kullanım Kılavuzu"
        sub="Manager ve Bayi işlemleri için ekran görüntülü, adım adım rehber."
        right={
          <div className="help-actions">
            <a className="lt-btn primary" href={PDF_URL} download="persas-kullanim-kilavuzu.pdf">⬇ PDF indir</a>
            <a className="lt-btn" href={PDF_URL} target="_blank" rel="noreferrer">Yeni sekmede aç</a>
          </div>
        }
      />
      <div className="help-viewer">
        <iframe title="Persaş Tahsilat — Kullanım Kılavuzu" src={PDF_URL} />
      </div>
    </div>
  );
}
